import { createElement, memo } from '@hfe/max';
import View from '@hfe/max-view';
import Image from '@hfe/max-image';
import Text from '@hfe/max-text';
import './SuggestAreaItem.scss';
import { getImage } from '../../util';
function SuggestAreaItem(p) {
    var _a;
    console.log(p.areaSuggest, 'suggest');
    return <View className="suggest-area-item-container" onClick={() => p.emitCity(p.areaSuggest, p.cityType)}>
      <View className="suggest-area-item-left">
        <Image className="suggest-area-item-icon" source={getImage('https://p0.meituan.net/travelcube/20cedfd450e06a9260d775e1a634bdac2015.png')} resizeMode={'cover'}/>
        <Text className="suggest-area-item-name">{(_a = p.areaSuggest) === null || _a === void 0 ? void 0 : _a.name} </Text>
      </View>
    </View>;
}
export default memo(SuggestAreaItem);
